<template>     
<div class="card ">
	<div class="dash-card-header"> 
		<div class="back-link pl-2">
			<button @click="hasHistory() ? $router.go(-1) : $router.push('/dashboard')">
				<img class="pull-left" src="@/assets/back.svg" >	
			</button>
		</div>
		<div class="title-div font-medium font-size-15"><img src="@/assets/fitme-quarter.svg" class="color-purple"> {{$t("contract")}}</div>
		<div class="logout-link">
			<img class="" src="@/assets/logout.svg" @click="logout">
		</div>
	</div>	
	
      <div class="  justify-center items-center pt-20">
		<!-- <form class="text-start"> -->

			<div  class="form-group col-sm-12 pl-8 pr-8"> <span class="col-sm-6">{{$t("Full time")}} </span>
				<!-- <span class="col-sm-6"> -->
					<label class="switch pull-right">
						<input type="checkbox" v-model="form.fulltime">
						<span class="slider round"></span>
					</label>
				<!-- </span> -->
			</div>
			<div class="form-group col-sm-12 pl-8 pr-8"> <span class="col-sm-6">{{$t("Part time")}}</span>
				<!-- <span class="col-sm-6"> -->
					<label class="switch pull-right">
						<input type="checkbox" v-model="form.parttime">
						<span class="slider round"></span>
					</label>
				<!-- </span> -->
			</div>
			<div  class="form-group col-sm-12 pl-8 pr-8"> <span class="col-sm-6">{{$t("Freelance")}}  </span>
				<!-- <span class="col-sm-6"> -->
					<label class="switch pull-right">
						<input type="checkbox" v-model="form.freelance">
						<span class="slider round"></span>
					</label>
				<!-- </span> -->
			</div>

			<div  class="form-group col-sm-12 pl-8 pr-8"> <span class="col-sm-6">{{$t("studentcontract")}}  </span>
				<!-- <span class="col-sm-6"> -->
					<label class="switch pull-right">
						<input type="checkbox" value="1" v-model="form.student">
						<span class="slider round"></span>
					</label>
				<!-- </span> -->
			</div>


			<div v-if="form.student === true" class="form-group col-sm-12">
			<div class="col-sm-12">
		 <h2>{{$t("studentfrequence")}}</h2>
	</div>
				<select class="form-select pull-right form-select-lg mt-5 dropdown-color" v-model="form.student240" >
					<option value="0" selected>{{$t("occasional")}}</option>
					<option value="1">{{$t("frequent")}}</option>
				</select>
			</div>
			
			
			<br>	
			<div v-if="error" class="form-group col-sm-12 text-center">
				<div class=" p-4 btn-danger">{{error}}</div>
			</div>
			<div v-if="update" class="form-group col-sm-12 mt-5">
				<button @click.prevent="saveForm" type="submit" class="btn bg-color-grblue btn-block" :disabled="loading">{{$t("save")}}</button>
			</div>
			<div v-else class="form-group col-sm-12 mt-5">
				<button @click.prevent="saveForm" type="submit" class="btn bg-color-grblue btn-block" :disabled="loading">{{$t("next")}}</button>
			</div>
		<!-- </form> -->
    </div>
</div>
</template>
<script>
export default {
	props: ['update'],
    data() {
        return {
            form: {
                student: false,
                student240: 0,
                fulltime: false,
                parttime: false,
                freelance: false,
				email: '',
				ukey:''
            },
            error: '',
			isUpdate: this.update,
			nextStepCheck: false
        }
    },
	mounted() {			
		window.scrollTo(0,0)
		let user = JSON.parse(localStorage.getItem('user'))
		
		if (user) {
			
			console.log(user.student);

			if (this.update == true || user.worktype.length >= 1 || user.student == '1' ) { 
				if(user.student=='1')
					this.form.student = true
				else
					this.form.student = false;
				this.form.student240 = user.student240;		
			}
			
			this.form.ukey = user.ukey
			if (user.worktype) {
				let types = user.worktype.split(";");
				if (types.includes('0')) {
					this.form.freelance = true;
				}
				if (types.includes('1')) {
					this.form.parttime = true;
				}
				if (types.includes('2')) {
					this.form.fulltime = true;
				}
			}

			if (!user.workdays && !user.worktime) {
				this.nextStepCheck = true;
			}
		}
	},
    methods:{
		hasHistory () { return window.history.length > 2 },
		async saveForm(){ 
			this.error = null;
			if (this.form.student == 5 ) {
				this.error = this.$t('pchoose')
				return;
			}
			if (!this.form.student && !this.form.fulltime && !this.form.parttime && !this.form.freelance ) {
				this.error = this.$t('pchoon')
				return;
			}
			try {
				await this.$store.dispatch('registerContract', this.form);

				if(this.update && !this.nextStepCheck) { 
					await this.$router.push({ name: 'dashboard', params: {lang: localStorage.getItem('locale')}});
					return;
				}

				await this.$router.push({ name: 'registerShifts', params: {lang: localStorage.getItem('locale')} });
					
			} catch (error) { 
				if (error.response && error.response.data && error.response.data.message) {
					this.error = error.response.data.message;
				}
			} 
         },
		 async logout(){ 
             this.error = null;
			try {
				await this.$store.dispatch('logout');
				await this.$router.push({ name: 'home' });
			} catch (error) {
				this.error = error;
			} finally {
				this.loading = false;
			}
         }
    }
}
</script>
